import React from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdb-react-ui-kit";
import transitionImage from '../img/medicalbillingservices/Outsourcingservices/Why-outsource.jpg';
import "../css/servicesfont.css";

const MedicalbillingDesc = () => {


  const customStyles = {
    section: {
      background: 'linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)',
      overflow: 'hidden',
      borderRadius: '20px',
      padding: '60px 40px', // Extra breathing room for the whole section
    },
    imageFrame: {
      position: 'relative',
      padding: '12px'      // More space around the image/graphic
    },
    shapeBg: {
      position: 'absolute',
      top: '0',
      left: '0',
      width: '100%',       // Slightly larger background glow
      height: '100%',
      background: 'rgba(111, 66, 193, 0.08)',
      borderRadius: '50%',
      zIndex: '0',
      filter: 'blur(60px)' // Smoother blur for the larger space
    },
    stepItem: {
      position: 'relative',
      paddingLeft: '60px',  // More distance from the vertical line
      marginBottom: '60px', // More distance between each step
      borderLeft: '2px solid #e0e0e0'
    },
    stepDot: {
      position: 'absolute',
      left: '-9px',
      top: '5px',
      width: '16px',
      height: '16px',
      backgroundColor: '#6f42c1',
      borderRadius: '50%',
      border: '3px solid #fff',
      boxShadow: '0 0 0 2px #6f42c1'
    }
  };
  const specialties = [
    { name: "Cardiology", colorRGB: "255, 94, 126", icon: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" },
    { name: "Dermatology", colorRGB: "76, 201, 240", icon: "M12 2s-8 6-8 10c0 4.42 3.58 8 8 8s8-3.58 8-8c0-4-8-10-8-10z" },

    /* NEW INFECTIOUS DISEASE ICON (Microbe/Pathogen Style) */
    { name: "Infectious Diseases", colorRGB: "72, 149, 239", icon: "M12,2L10.5,4.5L8,3.5L8.5,6L6,7L7.5,9.5L5,11L7.5,12.5L6,15L8.5,16L8,18.5L10.5,17.5L12,20L13.5,17.5L16,18.5L15.5,16L18,15L16.5,12.5L19,11L16.5,9.5L18,7L15.5,6L16,3.5L13.5,4.5L12,2M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z" },

    { name: "Pediatrics", colorRGB: "247, 37, 133", icon: "M12 12a4 4 0 100-8 4 4 0 000 8zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" },
    { name: "Internal Medicine", colorRGB: "114, 9, 183", icon: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z" },
    { name: "Gynecology", colorRGB: "181, 23, 158", icon: "M12 2c-3.31 0-6 2.69-6 6 0 2.59 1.64 4.8 3.94 5.61L9 18v2h2v2h2v-2h2v-2h-1.06L14.06 13.61C16.36 12.8 18 10.59 18 8c0-3.31-2.69-6-6-6z" },
    { name: "Psychiatry", colorRGB: "63, 55, 201", icon: "M12 22a7 7 0 007-7c0-2-1-3.9-3-5V5a3 3 0 00-6 0v5C8 11.1 7 13 7 15a7 7 0 007 7z" },
    { name: "Plastic Surgery", colorRGB: "86, 11, 173", icon: "M17 3l4 4-14 14-4-4L17 3z" },
    { name: "Urology", colorRGB: "67, 97, 238", icon: "M12 15a3 3 0 100-6 3 3 0 000 6zm0 2c-4 0-7 3-7 7h14c0-4-3-7-7-7z" },
    { name: "Surgical Practices", colorRGB: "72, 12, 168", icon: "M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71L12 2z" },
    { name: "Rheumatology", colorRGB: "58, 12, 163", icon: "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06z" }
  ];


  return (
    <MDBContainer fluid className="p-0 bg-light">
      {/* Introduction Section */}
      <div className="container py-2.5 px-md-1">
        <div style={{ display: 'flex', alignItems: 'center', gap: '40px', flexWrap: 'wrap', width: '100%', maxWidth: '2000px', margin: '0 auto' }}>

          {/* Left Side: Image with Decorative Shape */}
          <MDBCol lg="5" className="position-relative mb-5 mb-lg-0">
            <div style={customStyles.imageFrame}>
              <div style={customStyles.shapeBg}></div>
              <img
                src={transitionImage}
                alt="Dedicated AcerHealth medical billing support specialist assisting U.S. practices with outsourced revenue cycle management"
                className="img-fluid shadow-premium"
                style={{ borderRadius: '30px 10px 30px 10px', position: 'relative', zIndex: '1' }}
              />
            </div>
          </MDBCol>

          {/* Right Side: Content */}
          <div style={{ flex: '1.5', minWidth: '300px' }}>
            <h2 className="title AcerhealthTextPurple mb-4" style={{ fontFamily: 'Alegreya Sans', fontWeight: 'bold', fontSize: '32px' }}>
              Why Outsource Medical Billing in the USA?
            </h2>

            <p className="para-desc mb-4" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
              U.S. healthcare practices face increasing pressure to manage rising operational costs, staffing shortages, and complex billing regulations. Maintaining an in-house billing
              team requires continuous investment in hiring, training, and compliance management, which can strain resources and impact financial performance.
            </p>

            <p className="para-desc mb-4" style={{ fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
              <a
                href="https://acerhealth.com/blog/outsourcing-medical-billing-benefits"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#007BFF", textDecoration: "none", fontWeight: 'bold' }}
              >
                Outsourcing medical billing in the USA
              </a> allows practices to control costs, overcome staffing challenges, and stay compliant with payer requirements.
              By partnering with a specialized provider, healthcare organizations ensure consistent execution and maintain focus on patient care.
             For independent physicians, solo providers, and smaller healthcare organizations, our guide on <a
                href="https://acerhealth.com/blog/medical-billing-services-for-small-practices"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#007BFF", textDecoration: "none", fontWeight: 'bold' }}
              >
              medical billing services for small practices
              </a> explains how outsourcing can reduce administrative workload, improve cash flow, and support long-term practice growth.
            </p>
          </div>


        </div>

        {/* Workflow Section */}
        <style>{`
  .modern-steps { position: relative; padding-left: 20px; border-left: 3px solid #6c5ce722; }
  .step-card { 
    background: #fff; 
    border-radius: 12px; 
    padding: 23px; 
    transition: all 0.3s ease;
    border: 1px solid #f0f0f0;
    position: relative;
    margin-bottom: 30px;
  }
  .step-card:hover { 
    transform: translateX(10px);
    box-shadow: 0 10px 30px rgba(108, 92, 231, 0.1);
    border-color: #6c5ce7;
  }
  .step-badge {
    position: absolute;
    left: -33px;
    top: 25px;
    background: #6c5ce7;
    color: #fff;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
    box-shadow: 0 0 0 5px #fff;
  }
`}</style>

        <section className="py-5 overflow-hidden mt-5" style={{ backgroundColor: '#fcfcff', fontFamily: 'sans-serif' }}>
          <style>{`
        .process-wrapper {
          position: relative;
          padding: 20px 0;
        }

        /* The Connecting Line (Visible on Desktop) */
        @media (min-width: 992px) {
          .process-wrapper::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 10%;
            right: 10%;
            height: 2px;
            background: rgba(108, 92, 231, 0.15);
            z-index: 0;
            border-bottom: 2px dashed #6c5ce7;
            opacity: 0.3;
          }
        }

        .step-container {
          position: relative;
          z-index: 1;
        }

        .unique-card {
          background: #ffffff;
          border: none;
          border-radius: 24px;
          padding: 40px;
          text-align: center;
          box-shadow: 0 10px 40px rgba(0,0,0,0.04);
          transition: all 0.5s ease;
          height: 100%;
          border-top: 6px solid transparent;
        }

        .unique-card:hover {
          transform: translateY(-15px);
          box-shadow: 0 20px 50px rgba(108, 92, 231, 0.15);
          border-top-color: #6c5ce7;
        }

        .icon-orbit {
          width: 80px;
          height: 80px;
          background: #fff;
          border: 2px solid #6c5ce7;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 25px;
          font-size: 1.8rem;
          font-weight: 800;
          color: #6c5ce7;
          position: relative;
          transition: all 0.5s ease;
        }

        .unique-card:hover .icon-orbit {
          background: #6c5ce7;
          color: #fff;
          box-shadow: 0 0 20px rgba(108, 92, 231, 0.4);
        }

        .step-tag {
          text-transform: uppercase;
          font-size: 0.75rem;
          font-weight: 700;
          color: #6c5ce7;
          letter-spacing: 2px;
          background: rgba(108, 92, 231, 0.1);
          padding: 4px 12px;
          border-radius: 50px;
          margin-bottom: 15px;
          display: inline-block;
        }

        .text-gradient {
          background: linear-gradient(135deg, #6c5ce7 0%, #4834d4 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .card-title {
          font-weight: 800;
          font-size: 1.35rem;
          color: #2d3436;
          margin-bottom: 15px;
        }

        .card-body-text {
          color: #636e72;
          font-size: 0.95rem;
          line-height: 1.8;
        }

        .dot-indicator {
          width: 12px;
          height: 12px;
          background: #6c5ce7;
          border-radius: 50%;
          position: absolute;
          bottom: -46px;
          left: 50%;
          transform: translateX(-50%);
          display: none;
        }

        @media (min-width: 992px) {
          .dot-indicator { display: block; }
        }
      `}</style>

          <MDBContainer>
            <div className="text-center mb-5">

              <h2 className="main-title">
                How AcerHealth’s  <span className="text-gradient">Medical Billing Outsourcing Works</span>
              </h2>
              <p className="text-muted mx-auto" style={{ maxWidth: '800px', fontSize: '20px', fontFamily: 'Alegreya Sans', fontWeight: '500', }}>
                AcerHealth follows a structured outsourcing approach that allows U.S. healthcare practices to transition billing
                operations seamlessly while maintaining visibility and control. Our process is designed to ensure operational
                continuity, accountability, and measurable billing performance from onboarding through ongoing management.
              </p>
            </div>

            <div className="process-wrapper">
              <MDBRow className="g-5 step-container">
                {/* Stage 1 */}
                <MDBCol lg="4">
                  <div className="unique-card">
                    <div className="icon-orbit">
                      01
                    </div>

                    <h3 className="card-title">Onboarding & Transition</h3>
                    <p className="card-body-text" style={{ fontSize: '19px', fontFamily: 'Alegreya Sans', fontWeight: '500', }}>
                      AcerHealth initiates a structured onboarding process to align systems access, payer requirements,
                      and billing responsibilities. This transition is designed to integrate smoothly with existing operations
                      while ensuring continuity of billing activities from day one.Our team ensures secure system configuration
                      and workflow alignment to support efficient <a
                        href="https://acerhealth.com/services/revenue-cycle-management"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#007BFF", textDecoration: "none", fontWeight: 'bold' }}
                      >
                        revenue cycle management in the USA
                      </a>
                    </p>
                  </div>
                </MDBCol>

                {/* Stage 2 */}
                <MDBCol lg="4">
                  <div className="unique-card shadow-lg" style={{ borderTopColor: 'rgba(108, 92, 231, 0.3)' }}>
                    <div className="icon-orbit">
                      02

                    </div>

                    <h3 className="card-title">End-to-End Billing Operations Management</h3>
                    <p className="card-body-text" style={{ fontSize: '19px', fontFamily: 'Alegreya Sans', fontWeight: '500', }}>
                      Following onboarding, AcerHealth assumes responsibility for
                      <a href="https://acerhealth.com/blog/medical-billing-process" 
                      className="text-decoration-none fw-bold ms-1"
                       style={{ color: '#6c5ce7' }}>
                        day-to-day billing operations
                      </a>
                      across the 
                      <a 
                      href="https://acerhealth.com/services/revenue-cycle-management"
                        className="text-decoration-none fw-bold ms-1"
                        style={{ color: '#6c5ce7' }}>
                        revenue cycle management.
                      </a>
                       All billing activities — including claim submission, payment posting, denial follow-ups, and reporting — 
                       are managed through standardized workflows and quality controls to support accuracy, consistency, and timely reimbursements.
                    </p>
                  </div>
                </MDBCol>


                <MDBCol lg="4">
                  <div className="unique-card">
                    <div className="icon-orbit">
                      03
                    </div>

                    <h3 className="card-title">Performance Visibility & Reporting</h3>
                    <p className="card-body-text" style={{ fontSize: '19px', fontFamily: 'Alegreya Sans', fontWeight: '500', }}>
                     Ongoing performance reporting provides practices with visibility into billing activity, claim progress, and reimbursement outcomes.
                      This structured reporting framework supports transparency across 
                        <a 
                      href="https://acerhealth.com/blog/types-of-medical-billing-and-rcm-impact"
                        className="text-decoration-none fw-bold ms-1"
                        style={{ color: '#6c5ce7' }}>
                        revenue cycle management.
                      </a> while allowing healthcare providers 
                      to retain oversight without managing billing tasks internally.
                    </p>
                  </div>
                </MDBCol>
              </MDBRow>
            </div>
          </MDBContainer>
        </section>

        <section className="specialty-modern-section">
          <MDBContainer>
            <div className="header-wrapper text-center">

              <h2 className="main-title">
                Specialties We Support <span className="text-gradient">Across the USA</span>
              </h2>
              <p className="custom-subtitle">
                <b>AcerHealth provides <a
                  href="https://acerhealth.com/blog/outsourcing-medical-billing-questions"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#007BFF", textDecoration: "none", fontWeight: 'bold' }}
                >
                  medical billing outsourcing services
                </a>
                  for a broad range of healthcare specialties across the USA. Our billing teams are experienced
                  in handling specialty-specific documentation, coding requirements, and payer rules while 
                  maintaining consistent workflows and reporting standards.</b>
              </p>
            </div>

            <MDBRow className="g-4 mt-5">
              {specialties.map((item, index) => (
                <MDBCol key={index} xl="3" lg="4" md="6">
                  <div className="specialty-card-outer" style={{ '--accent-rgb': item.colorRGB }}>
                    <div className="specialty-card-inner">
                      <div className="icon-box">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d={item.icon} />
                        </svg>
                      </div>

                      <p className="specialty-name">{item.name}</p>
                      <div className="card-arrow">→</div>
                    </div>
                  </div>
                </MDBCol>
              ))}
            </MDBRow>

            <div className="footer-trust mt-5">
              <div className="trust-pill">
                <p className="para-desc mx-auto mb-0" style={{ fontSize: '18px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
                  Whether supporting
                  <a
                    href="https://acerhealth.com/blog/medical-billing-services-for-small-practices"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#007BFF", textDecoration: "none", fontWeight: 'bold' }}
                  >
                    single-specialty clinics or multi-specialty practices
                  </a>
                  , AcerHealth adapts billing operations to align with each
                  specialty’s reimbursement requirements while ensuring accuracy, compliance, and predictable cash flow.</p>
              </div>
            </div>
          </MDBContainer>

          <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .specialty-modern-section {
          background: #f8faff;
          padding: 80px 0;
          font-family: 'Plus Jakarta Sans', sans-serif;
          position: relative;
        }

        /* Background Decor */
        .specialty-modern-section::before {
          content: "";
          position: absolute;
          top: 0; left: 0; width: 100%; height: 100%;
          background: radial-gradient(circle at 10% 20%, rgba(67, 97, 238, 0.03) 0%, transparent 50%),
                      radial-gradient(circle at 90% 80%, rgba(114, 9, 183, 0.03) 0%, transparent 50%);
          pointer-events: none;
        }

        .badge-pill {
          background: #ffffff;
          color: #4361ee;
          padding: 8px 20px;
          border-radius: 50px;
          font-weight: 700;
          font-size: 0.75rem;
          text-transform: uppercase;
          letter-spacing: 1.5px;
          box-shadow: 0 4px 15px rgba(0,0,0,0.05);
          display: inline-block;
          margin-bottom: 20px;
          border: 1px solid rgba(67, 97, 238, 0.1);
        }

        .main-title {
          font-weight: 600;
          font-size: clamp(2rem, 5vw, 2.75rem);
          color: #0f172a;
          margin-bottom: 1.5rem;
        }

        .text-gradient {
          background: linear-gradient(135deg, #4361ee, #7209b7);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .custom-subtitle {
          color: #64748b;
          max-width: 1000px;
          margin: 0 auto;
        fontSize: '18px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify'
        }

        /* The Card Design */
        .specialty-card-outer {
          position: relative;
          background: #ffffff;
          border-radius: 24px;
          padding: 30px;
          height: 100%;
          border: 1px solid #eef2f6;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          overflow: hidden;
          z-index: 1;
        }

        .specialty-card-outer::before {
          content: "";
          position: absolute;
          top: 0; left: 0; width: 100%; height: 100%;
          background: radial-gradient(circle at top right, rgba(var(--accent-rgb), 0.12), transparent 70%);
          opacity: 0;
          transition: opacity 0.4s ease;
          z-index: -1;
        }

        .specialty-card-outer:hover {
          transform: translateY(-8px);
          border-color: rgba(var(--accent-rgb), 0.4);
          box-shadow: 0 20px 40px -15px rgba(var(--accent-rgb), 0.15);
        }

        .specialty-card-outer:hover::before {
          opacity: 1;
        }

        .icon-box {
          width: 50px;
          height: 50px;
          background: rgba(var(--accent-rgb), 0.1);
          color: rgb(var(--accent-rgb));
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          transition: all 0.4s ease;
        }

        .icon-box svg {
          width: 26px;
          height: 26px;
        }

        .specialty-card-outer:hover .icon-box {
          background: rgb(var(--accent-rgb));
          color: #fff;
          transform: rotate(-5deg) scale(1.1);
        }

        .specialty-name {
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 8px;
          font-size: 1.15rem;
        }

        .specialty-desc {
          font-size: 0.85rem;
          color: #94a3b8;
          margin-bottom: 0;
        }

        .card-arrow {
          position: absolute;
          bottom: 25px;
          right: 30px;
          color: rgb(var(--accent-rgb));
          opacity: 0;
          transform: translateX(-10px);
          transition: all 0.3s ease;
          font-weight: bold;
        }

        .specialty-card-outer:hover .card-arrow {
          opacity: 1;
          transform: translateX(0);
        }

        /* Footer Pill */
        .footer-trust {
          display: flex;
          justify-content: center;
          margin-top: 50px;
        }

        .trust-pill {
          background: #fff;
          padding: 10px 25px;
          border-radius: 100px;
          border: 1px solid #e2e8f0;
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 0.9rem;
          color: #475569;
          box-shadow: 0 4px 6px rgba(0,0,0,0.02);
        }

        .pulse-dot {
          width: 8px;
          height: 8px;
          background: #10b981;
          border-radius: 50%;
          position: relative;
        }

        .pulse-dot::after {
          content: "";
          position: absolute;
          width: 100%; height: 100%;
          background: inherit;
          border-radius: inherit;
          animation: pulse 2s infinite;
        }

        @keyframes pulse {
          0% { transform: scale(1); opacity: 0.8; }
          100% { transform: scale(3); opacity: 0; }
        }
      `}</style>
        </section>

        <section className="benefits-modern-section">
          <MDBContainer>
            <div className="header-wrapper text-center mb-5">

              <h2 className="main-title">
                Benefits of Outsourcing Medical Billing to  <span className="text-gradient">AcerHealth</span>
              </h2>
              <p className="custom-subtitle">
               AcerHealth’s<b>medical billing outsourcing services in the USA </b> deliver measurable financial and 
               operational improvements for healthcare practices by combining structured workflows,
                 <a
                    href="https://acerhealth.com/services/revenue-cycle-management"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#007BFF", textDecoration: "none", fontWeight: 'bold' }}
                  >
                   revenue cycle management (RCM)
                  </a>
                  , Acer
                 expertise, and compliance-driven processes.
              </p>
            </div>

            <MDBRow className="g-4">
              {/* Card 1 - Faster Reimbursements */}
              <MDBCol lg="6" md="12">
                <div className="benefit-card primary-gradient">
                  <div className="benefit-content">
                    <div className="benefit-icon-wrapper">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                      </svg>
                    </div>
                    <div className="text-content">
                      <p className="benefit-label">Card 1 — Faster Reimbursements</p>
                      <p className="benefit-heading">Accelerated Payment Cycles</p>
                      <p className="benefit-text">
                       Through optimized 

                         <a
                    href="https://acerhealth.com/blog/revenue-cycle-management-explained"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#007BFF", textDecoration: "none", fontWeight: 'bold' }}
                  >
                   revenue cycle management (RCM) workflows
                  </a>, timely claim submissions, and 
                  proactive payer follow-ups, AcerHealth helps reduce processing delays and accelerate 
                  reimbursement timelines for U.S. healthcare practices. Improved clean claim 
                  rates directly support healthier cash flow.
                      </p>
                    </div>
                  </div>

                </div>
              </MDBCol>

              {/* Card 2 - Denial Reduction */}
              <MDBCol lg="6" md="12">
                <div className="benefit-card success-gradient">
                  <div className="benefit-content">
                    <div className="benefit-icon-wrapper">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                        <polyline points="22 4 12 14.01 9 11.01" />
                      </svg>
                    </div>
                    <div className="text-content">
                      <p className="benefit-label">Card 2 — Denial Reduction</p>
                      <p className="benefit-heading">Lower Denial Rates</p>
                      <p className="benefit-text">
                       Our structured    <a
                          href="https://acerhealth.com/services/denial-management-services"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#007BFF", textDecoration: "none", fontWeight: 'bold' }}
                        >
                          healthcare denial management
                        </a>  protocols and multi-layer quality checks minimize avoidable billing errors.
                         By strengthening front-end verification and coding accuracy, we improve first-pass
                          claim acceptance and support measurable denial rate reduction.
                      </p>
                    </div>
                  </div>

                </div>
              </MDBCol>

              {/* Card 3 - HIPAA Compliance */}
              <MDBCol lg="6" md="12">
                <div className="benefit-card info-gradient">
                  <div className="benefit-content">
                    <div className="benefit-icon-wrapper">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                      </svg>
                    </div>
                    <div className="text-content">
                      <p className="benefit-label">Card 3 — HIPAA Compliance</p>
                      <p className="benefit-heading">Secure & Compliant Billing Operations</p>
                      <p className="benefit-text">
                     Our <a
                          href="https://acerhealth.com/services/contract-compliance"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#007BFF", textDecoration: "none", fontWeight: 'bold' }}
                        >
                         medical billing compliance services
                        </a>  follow strict HIPAA regulations and data security standards. 
                     Secure system access controls, encrypted data handling, and continuous monitoring ensure patient 
                     and billing information remain protected across the revenue cycle.
                      </p>
                    </div>
                  </div>
                </div>
              </MDBCol>

              {/* Card 4 - Reduced Admin Burden */}
              <MDBCol lg="6" md="12">
                <div className="benefit-card purple-gradient">
                  <div className="benefit-content">
                    <div className="benefit-icon-wrapper">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                        <circle cx="9" cy="7" r="4" />
                        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                      </svg>
                    </div>
                    <div className="text-content">
                      <p className="benefit-label">Card 4 — Reduced Administrative Burden</p>
                      <p className="benefit-heading">Less Internal Workload</p>
                      <p className="benefit-text">
                       With AcerHealth managing day-to-day billing operations under a structured medical billing 
                       outsourcing model, internal teams can focus on patient care, clinical efficiency, and 
                       practice growth rather than claim follow-ups and payer communication.
                      </p>
                    </div>
                  </div>

                </div>
              </MDBCol>
            </MDBRow>
          </MDBContainer>

          <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&display=swap');

    .benefits-modern-section {
      background: #ffffff;
      padding: 100px 0;
      font-family: 'Plus Jakarta Sans', sans-serif;
    }

    .benefit-badge {
      display: inline-block;
      padding: 6px 16px;
      background: rgba(67, 97, 238, 0.08);
      color: #4361ee;
      border-radius: 100px;
      font-weight: 700;
      font-size: 0.8rem;
      text-transform: uppercase;
      margin-bottom: 1rem;
    }

    .main-title {
      font-weight: 700;
      font-size: clamp(2rem, 4vw, 2.3rem);
      color: #0f172a;
    }

    .text-gradient {
      background: linear-gradient(135deg, #4361ee, #7209b7);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .custom-subtitle {
      color: #64748b;
      max-width: 900px;
      margin: 1.5rem auto 0;
     
        fontSize: '19.8px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify'
    }

    .benefit-card {
      position: relative;
      padding: 40px;
      border-radius: 32px;
      height: 100%;
      border: 1px solid #f1f5f9;
      transition: all 0.3s ease;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    /* Gradient Variants */
    .primary-gradient { background: linear-gradient(145deg, #ffffff 0%, #f8faff 100%); }
    .success-gradient { background: linear-gradient(145deg, #ffffff 0%, #f7fffb 100%); }
    .info-gradient { background: linear-gradient(145deg, #ffffff 0%, #f0f7ff 100%); }
    .purple-gradient { background: linear-gradient(145deg, #ffffff 0%, #faf8ff 100%); }

    .benefit-card:hover {
      transform: translateY(-5px);
      box-shadow: 0 20px 40px rgba(15, 23, 42, 0.05);
    }

    .benefit-content {
      display: flex;
      gap: 24px;
    }

    .benefit-icon-wrapper {
      flex-shrink: 0;
      width: 56px;
      height: 56px;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /* Dynamic Icon Colors */
    .primary-gradient .benefit-icon-wrapper { background: #4361ee; color: white; }
    .success-gradient .benefit-icon-wrapper { background: #10b981; color: white; }
    .info-gradient .benefit-icon-wrapper { background: #0ea5e9; color: white; }
    .purple-gradient .benefit-icon-wrapper { background: #7209b7; color: white; }

    .benefit-icon-wrapper svg { width: 28px; height: 28px; }

    .benefit-label {
      font-size: 0.85rem;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-bottom: 8px;
    }
    
    .primary-gradient .benefit-label { color: #4361ee; }
    .success-gradient .benefit-label { color: #10b981; }
    .info-gradient .benefit-label { color: #0ea5e9; }
    .purple-gradient .benefit-label { color: #7209b7; }

    .benefit-heading {
      font-weight: 700;
      color: #1e293b;
      font-size: 1.4rem;
      margin-bottom: 12px;
    }

    .benefit-text {
      color: #64748b;
      line-height: 1.6;
    
      margin-bottom: 0;
            fontSize: '19.8px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify'
    }

    .metric-tag {
      margin-top: 25px;
      font-size: 0.75rem;
      font-weight: 800;
      padding: 4px 12px;
      background: #fff;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      width: fit-content;
      color: #94a3b8;
    }

    @media (max-width: 768px) {
      .benefit-content { flex-direction: column; }
      .benefit-card { padding: 30px; }
    }
  `}</style>
        </section>
        <section className="why-choose-acer-section">
          <MDBContainer>
            <MDBRow className="align-items-center g-5">
              {/* Left Side: Visual Branding */}
              <MDBCol lg="5">
                <div className="branding-visual">

                  <h2 className="display-title">
                    Why Choose <span className="text-highlight">AcerHealth </span> for Medical Billing Outsourcing
                  </h2>
                  <p className="para-desc mx-auto mb-0" style={{ fontSize: '19px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
                   AcerHealth is a trusted provider of <a
                          href="https://acerhealth.com/blog/outsourcing-medical-billing-benefits"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#007BFF", textDecoration: "none", fontWeight: 'bold' }}
                        >
                        medical billing outsourcing services in the USA
                        </a>  for healthcare practices seeking consistency, 
                   accountability, and financial clarity. Our outsourcing model is structured to strengthen revenue cycle management (RCM)
                    performance while maintaining transparency and operational control.
                  </p>

                </div>
              </MDBCol>

              {/* Right Side: Unique Feature Steps */}
              <MDBCol lg="7">
                <div className="features-list">

                  <div className="feature-item">
                    <div className="feature-marker">01</div>
                    <div className="feature-content">
                      <h3 className="feature-heading">Experienced Medical Billing Operations</h3>
                      <p className="para-desc mx-auto mb-0" style={{ fontSize: '19px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
                       AcerHealth brings proven expertise in managing end-to-end <a
                          href="https://acerhealth.com/services/medical-billing-services"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#007BFF", textDecoration: "none", fontWeight: 'bold' }}
                        >
                       medical billing services
                        </a> across diverse specialties. Structured workflows, 
                       standardized quality controls, and defined performance benchmarks support reliable reimbursement outcomes.
                      </p>
                    </div>
                  </div>

                  <div className="feature-item">
                    <div className="feature-marker">02</div>
                    <div className="feature-content">
                      <h3 className="feature-heading">Dedicated to U.S. Healthcare Billing</h3>
                      <p className="para-desc mx-auto mb-0" style={{ fontSize: '19px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
                        Our services are aligned exclusively with U.S. payer requirements, reimbursement methodologies, and regulatory standards. 
                        This focused approach supports compliant<a
                          href="https://acerhealth.com/services/revenue-cycle-management"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#007BFF", textDecoration: "none", fontWeight: 'bold' }}
                        >
                       revenue cycle management in the USA
                        </a>  and dependable claim processing.
                      </p>
                    </div>
                  </div>

                  <div className="feature-item">
                    <div className="feature-marker">03</div>
                    <div className="feature-content">
                      <h3 className="feature-heading">Clear Visibility and Accountability</h3>
                      <p className="para-desc mx-auto mb-0" style={{ fontSize: '19px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
                       Healthcare practices receive consistent performance reporting, claim status transparency, and measurable billing insights. 
                       This ensures oversight and financial clarity without internal administrative burden.
                      </p>
                    </div>
                  </div>

                  <div className="feature-item">
                    <div className="feature-marker">04</div>
                    <div className="feature-content">
                      <h3 className="feature-heading">Built for Long-Term Growth</h3>
                      <p className="para-desc mx-auto mb-0" style={{ fontSize: '19px', fontFamily: 'Alegreya Sans', fontWeight: '500', textAlign: 'justify' }}>
                       AcerHealth’s scalable 
                       <a
                          href="https://acerhealth.com/blog/outsourcing-medical-billing-questions"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#007BFF", textDecoration: "none", fontWeight: 'bold' }}
                        >
                       medical billing outsourcing
                        </a>  model adapts to evolving practice volumes and complexity,
                        delivering operational continuity and sustained revenue cycle performance over time.
                      </p>
                    </div>
                  </div>

                </div>
              </MDBCol>
            </MDBRow>
          </MDBContainer>

          <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Alegreya+Sans:wght@500;700;800&family=Plus+Jakarta+Sans:wght@800&display=swap');

    .why-choose-acer-section {
      padding: 100px 0;
      background-color: #ffffff;
      overflow: hidden;
    }

    .display-title {
     font-family: 'Plus Jakarta Sans', sans-serif;
      font-weight: 650;
      font-size: 2.35rem;
      color: #0f172a;
      line-height: 1.1;
      margin-bottom: 25px;
    }

    .text-highlight {
      color: #4361ee;
      position: relative;
    }

    .intro-text {
      font-family: 'Alegreya Sans', sans-serif;
      font-size: 22px;
      font-weight: 500;
      color: #334155;
      line-height: 1.5;
    }

    /* Unique Feature Layout */
    .features-list {
      position: relative;
      padding-left: 20px;
    }

    .feature-item {
      display: flex;
      gap: 30px;
      margin-bottom: 40px;
      position: relative;
    }

    .feature-marker {
      flex-shrink: 0;
      width: 50px;
      height: 50px;
      background: #f1f5f9;
      color: #4361ee;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 800;
      border-radius: 12px;
      font-size: 1.2rem;
      transition: all 0.3s ease;
    }

    .feature-item:hover .feature-marker {
      background: #4361ee;
      color: #fff;
      transform: scale(1.1);
    }

    .feature-heading {
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-weight: 700;
      font-size: 1.5rem;
      color: #0f172a;
      margin-bottom: 8px;
    }

    .feature-desc {
      font-family: 'Alegreya Sans', sans-serif;
      font-size: 20px; /* Bright and Large */
      font-weight: 500; /* Bold visible weight */
      color: #1e293b; /* Deep high-contrast color */
      line-height: 1.6;
      text-align: justify;
      margin-bottom: 0;
    }

    /* Branding Visual Elements */
    .experience-badge {
      display: inline-flex;
      flex-direction: column;
      background: #4361ee;
      color: white;
      padding: 15px 25px;
      border-radius: 20px;
      margin-bottom: 30px;
    }

    .experience-badge .number { font-size: 2rem; font-weight: 800; line-height: 1; }
    .experience-badge .label { font-size: 0.8rem; text-transform: uppercase; font-weight: 700; }

    .growth-chart-deco {
      display: flex;
      align-items: flex-end;
      gap: 10px;
      margin-top: 40px;
      height: 60px;
    }

    .bar { width: 12px; background: #e2e8f0; border-radius: 4px; transition: height 1s; }
    .b1 { height: 30%; } .b2 { height: 50%; } .b3 { height: 80%; } .b4 { height: 100%; background: #4361ee; }

    @media (max-width: 991px) {
      .display-title { font-size: 2.5rem; }
      .why-choose-acer-section { text-align: center; }
      .feature-desc { text-align: center; }
      .feature-item { flex-direction: column; align-items: center; gap: 15px; }
      .growth-chart-deco { justify-content: center; }
    }
  `}</style>
        </section>
        <section className="onboarding-horizontal-section">
          <MDBContainer fluid className="px-md-5">
            {/* Header Section */}
            <div className="header-wrapper text-center mb-5">
              <h2 className="main-title">
                Get Started with <span className="text-gradient">Medical Billing Outsourcing</span>
              </h2>
              <p className="custom-subtitle mx-auto" style={{ fontSize: '19px', fontFamily: 'Alegreya Sans', fontWeight: '500', }} >
                AcerHealth makes it simple for healthcare practices to transition to structured <b>medical billing outsourcing services in the USA</b> with 
                minimal operational disruption. Our onboarding framework is designed to align with your practice structure, payer requirements,
                 and  <a
                          href="https://acerhealth.com/services/revenue-cycle-management"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#007BFF", textDecoration: "none", fontWeight: 'bold' }}
                        >
                       revenue cycle management (RCM)
                        </a>  goals.
              </p>
            </div>

            <div className="horizontal-flow-container">
              {/* Background Track Line */}
              <div className="timeline-track"></div>

              <div className="steps-grid">
                {/* Phase 01 */}
                <div className="step-station">
                  <div className="station-head">
                    <div className="station-blob">01</div>
                    <div className="station-line"></div>
                  </div>
                  <div className="horizontal-card">
                    <div className="card-inner">

                      <h3>Start With a Consultation</h3>
                      <p className="card-body-text" style={{ fontSize: '19px', fontFamily: 'Alegreya Sans', fontWeight: '500', }}>
                        Speak with an AcerHealth billing specialist to review your current billing challenges, payer mix, and outsourcing requirements.
                         This initial consultation helps determine the right outsourcing model for your practice.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Phase 02 */}
                <div className="step-station">
                  <div className="station-head">
                    <div className="station-blob">02</div>
                    <div className="station-line"></div>
                  </div>
                  <div className="horizontal-card">
                    <div className="card-inner">

                      <h3>Seamless Transition to Outsourced Billing</h3>
                      <p className="card-body-text" style={{ fontSize: '19px', fontFamily: 'Alegreya Sans', fontWeight: '500', }}>
                       Once engaged, AcerHealth manages the onboarding and transition process, ensuring continuity of billing
                        operations while establishing workflows, reporting, and accountability.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Phase 03 - Featured */}
                <div className="step-station featured">
                  <div className="station-head">
                    <div className="station-blob">03</div>
                    <div className="station-line"></div>
                  </div>
                  <div className="horizontal-card highlight">
                    <div className="card-inner">

                      <h3>Request a Medical Billing Outsourcing Consultation</h3>
                      <p className="card-body-text" style={{ fontSize: '19px', fontFamily: 'Alegreya Sans', fontWeight: '500', }}>
                       Ready to streamline billing operations and improve financial performance? Contact AcerHealth to discuss 
                       medical billing outsourcing services tailored for U.S. healthcare practices.
                      </p>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </MDBContainer>

          <style>{`
    .onboarding-horizontal-section {
      padding: 100px 0;
      background: #fafbff;
      font-family: 'Plus Jakarta Sans', sans-serif;
      overflow-x: hidden;
    }

    .main-title {
      font-size: 2.5rem;
      font-weight: 800;
      color: #0f172a;
      letter-spacing: -1px;
    }

    .text-gradient {
      background: linear-gradient(135deg, #4361ee 0%, #3a0ca3 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    .custom-subtitle {
      max-width: 800px;
      color: #64748b;
      font-size: 1.05rem;
      line-height: 1.6;
    }

    .horizontal-flow-container {
      position: relative;
      margin-top: 80px;
      padding-bottom: 50px;
    }

    .timeline-track {
      position: absolute;
      top: 25px;
      left: 0;
      width: 100%;
      height: 2px;
      background: rgba(67, 97, 238, 0.1);
      z-index: 1;
    }

    .steps-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 30px;
      position: relative;
      z-index: 2;
    }

    .step-station {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .station-head {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 30px;
    }

    .station-blob {
      width: 54px;
      height: 54px;
      background: white;
      border: 3px solid #4361ee;
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 800;
      color: #4361ee;
      box-shadow: 0 10px 20px rgba(67, 97, 238, 0.15);
      transition: 0.3s ease;
      z-index: 3;
    }

    .featured .station-blob {
      background: #4361ee;
      color: white;
      transform: scale(1.1);
    }

    .station-line {
      width: 2px;
      height: 40px;
      background: linear-gradient(to bottom, #4361ee, transparent);
    }

    .horizontal-card {
      background: white;
      border-radius: 24px;
      padding: 30px;
      border: 1px solid #f1f5f9;
      box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px -1px rgba(0, 0, 0, 0.01);
      transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
      height: 100%;
    }

    .horizontal-card:hover {
      transform: translateY(-8px);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.06);
      border-color: #4361ee;
    }

    .horizontal-card.highlight {
      background: #ffffff;
      border: 2px solid #4361ee;
      position: relative;
    }

    .phase-label {
      font-size: 0.7rem;
      text-transform: uppercase;
      font-weight: 800;
      color: #4361ee;
      letter-spacing: 1.5px;
      display: block;
      margin-bottom: 12px;
    }

    .horizontal-card h3 {
      font-size: 1.2rem;
      font-weight: 700;
      color: #0f172a;
      margin-bottom: 15px;
      line-height: 1.3;
    }

    .horizontal-card p {
      font-size: 0.95rem;
      color: #64748b;
      line-height: 1.6;
      margin-bottom: 0;
    }

    .station-cta {
      margin-top: 20px;
      width: 100%;
      background: #4361ee;
      color: white;
      border: none;
      padding: 10px;
      border-radius: 12px;
      font-weight: 700;
      font-size: 0.9rem;
      transition: 0.3s;
    }

    .station-cta:hover {
      background: #3a0ca3;
      box-shadow: 0 8px 15px rgba(67, 97, 238, 0.3);
    }

    @media (max-width: 992px) {
      .steps-grid {
        grid-template-columns: 1fr;
        gap: 50px;
      }
      .timeline-track, .station-line {
        display: none;
      }
      .horizontal-flow-container {
        margin-top: 40px;
      }
      .horizontal-card {
        text-align: center;
      }
    }
  `}</style>
        </section>


        <h2
          style={{
            fontSize: "26px",
            fontFamily: "Alegreya Sans",
            color: "#6A0DAD",
            marginBottom: "8px"   // tighter gap
          }}
        >
          <b>Frequently Asked Questions </b>
        </h2>

        <p className=""
          style={{
            fontSize: "18px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            textAlign: "justify",
            marginBottom: "8px"
          }}
        >
          <b>1. Who should use medical billing outsourcing services in the USA? </b></p>

        <p className=""
          style={{
            fontSize: "18px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            textAlign: "justify",
            marginBottom: "8px"
          }}
        >
          Medical billing outsourcing is ideal for U.S. healthcare practices seeking to reduce administrative burden,
          manage staffing challenges, and improve billing efficiency while maintaining compliance with payer and regulatory requirements.</p>

        <p className=""
          style={{
            fontSize: "18px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            textAlign: "justify",
            marginBottom: "8px"
          }}
        >
          <b>2. Does AcerHealth provide medical billing outsourcing only for U.S. practices? </b></p>


        <p className=""
          style={{
            fontSize: "18px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            textAlign: "justify",
            marginBottom: "8px"
          }}
        >
          Yes. AcerHealth’s medical billing outsourcing services are designed exclusively for U.S.
          healthcare practices and aligned with U.S. payer rules, reimbursement models, and regulatory standards.</p>

        <p className=""
          style={{
            fontSize: "18px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            textAlign: "justify",
            marginBottom: "8px"
          }}
        >
          <b>3. How does outsourcing medical billing improve cash flow? </b></p>


        <p className=""
          style={{
            fontSize: "18px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            textAlign: "justify",
            marginBottom: "8px"
          }}
        >
          Outsourcing medical billing helps improve cash flow by reducing claim errors, accelerating claim submission,
          and ensuring consistent follow-up on unpaid or denied claims through structured billing workflows.</p>

        <p className=""
          style={{
            fontSize: "18px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            textAlign: "justify",
            marginBottom: "8px"
          }}
        >
          <b>4. Is medical billing outsourcing with AcerHealth HIPAA compliant? </b></p>


        <p className=""
          style={{
            fontSize: "18px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            textAlign: "justify",
            marginBottom: "8px"
          }}
        >
          Yes. AcerHealth follows HIPAA-compliant processes and security controls to protect patient data and billing information throughout the outsourcing engagement.</p>

        <p className=""
          style={{
            fontSize: "18px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            textAlign: "justify",
            marginBottom: "8px"
          }}
        >
          <b>5. How long does it take to transition to medical billing outsourcing?</b></p>


        <p className=""
          style={{
            fontSize: "18px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            textAlign: "justify",
            marginBottom: "8px"
          }}
        >
          The transition timeline depends on practice size and complexity, but AcerHealth follows
          a structured onboarding process to ensure a smooth and efficient transition with minimal disruption to billing operations.</p>

        <p className=""
          style={{
            fontSize: "18px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            textAlign: "justify",
            marginBottom: "8px"
          }}
        >
          <b>6. Will I have visibility into my outsourced billing performance?</b></p>


        <p className=""
          style={{
            fontSize: "18px",
            fontFamily: "Alegreya Sans",
            fontWeight: "500",
            textAlign: "justify",
            marginBottom: "8px"
          }}
        >
          Yes. AcerHealth provides regular billing reports and performance visibility so
          practices can track claim status, denials, and reimbursement outcomes without managing day-to-day billing tasks.</p>



      </div>
    </MDBContainer>
  );
};

export default MedicalbillingDesc;